/**
 * « Entraînement » — la rangée de sous-onglets au-dessus de chaque écran.
 *
 * Même forme que les entraînements du parent (`v2/V2ChildLayout`) : la rangée
 * est dessinée par la route parente, au-dessus de l'`<Outlet/>`, sans quoi
 * suivre un sous-onglet remplacerait la page entière, rangée comprise.
 *
 * L'onglet n'existe qu'au lycée (`profile.ownTraining`) ; les routes, elles,
 * répondent aux deux enfants, comme « Ma carte » : réserver la route ferait
 * d'un choix d'écran une autorisation, et c'est le serveur qui décide de ce
 * que l'élève peut composer.
 */

import { Outlet } from "react-router-dom";

import { ongletsDeMonEntrainement } from "@/child/monEntrainement";
import { SousOnglets } from "@/ui/SousOnglets";

export function MonEntrainementLayout() {
  return (
    <>
      <SousOnglets tabs={ongletsDeMonEntrainement()} label="Mon entraînement" />
      <Outlet />
    </>
  );
}
